// extracted by mini-css-extract-plugin
export default {"container":"Form_container__sdsoy"};